import { Deserializable } from './deserializable';
import { BaseModel } from './baseModel';
import { DateHelper } from '../util/dateHelper';
import { AliasOwnerRel } from './AliasOwnerRel';
import { UploadedFile } from './UploadedFile';


export class NewUserRequest extends BaseModel implements Deserializable {

  id: number;

  ownerUid: string;

  aliasUid: string;

  alias: AliasOwnerRel;

  email: string;

  firstname: string;
  lastname: string;

  licensePlate: string;

  phoneNumber: string;
  prefix: string;

  notes: string;

  accepted: boolean;

  rejected: boolean;

  acceptRejectNotes: string;

  state: string;

  createdAt: Date;

  updateAt: Date;

  //new

  approvedBy: string;

  expirationDate: Date;

  startDate: Date;

  tableDate: string;

  language: string;

  files: UploadedFile[];

  documents: UploadedFile[];

  deserialize(input: any) {

    super.deserialize(input);
    Object.assign(this, input);

    this.createdAt = new Date(this.createdAt);

    this.tableDate = DateHelper.formatShortDateFriendly(this.createdAt);

    //per gestire vecchi nomi cablati su visualizzazione nuova
    if (this.documents && this.documents.length > 0) {
      for (let doc of this.documents) {
        if (doc.description == "ci") {
          doc.description = "Carta di identità";
        } else if (doc.description == "room") {
          doc.description = "Documentazione stanze e/o appartamenti";
        } else if (doc.description == "cir") {
          doc.description = "Codice Identificativo di Riferimento della struttura ricettiva";
        }
      }
    }

    this.updateState();

    return this;
  }

  updateState() {
    if (this.rejected) {
      this.state = $localize`:@@new_user_request_rejected:Rifiutata`;
    } else if (this.accepted) {
      this.state = $localize`:@@new_user_request_accepted:Accettata`;
    } else {
      this.state = $localize`:@@new_user_request_pending:In sospeso`;
    }
  }
}
